import { FormGroup, Icon, IconName, MaybeElement } from "@blueprintjs/core";
import React from "react";
import { FieldLabel } from "../FieldLabel/FieldLabel";
import { FormFieldErrorContainer } from "../FieldError/FormFieldErrorContainer";
import { FieldLabeledProps, ReadOnlyProps } from "../../types/fieldTypes";
import classNames from "classnames";

export interface ReadOnlyFieldProps extends ReadOnlyProps {
  leftIcon?: IconName | MaybeElement;
  minimal?: boolean;
  labelProps?: FieldLabeledProps;
}

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = (props) => {
  const [ready, setReady] = React.useState<boolean>(false);
  const [readOnlySettings, setReadOnlySettings] =
    React.useState<ReadOnlyFieldProps>();

  React.useEffect(() => {
    setup();
  }, []);

  const defaultReadOnlySettings = {};

  // Setup
  const setup = async () => {
    // Setup Properties
    const settings = {
      ...defaultReadOnlySettings,
      ...props,
    } as ReadOnlyFieldProps;

    setReadOnlySettings(settings);
    setReady(true);
  };

  return (
    <FormGroup>
      {props.label && (
        <FieldLabel
          labelName={props.label}
          tooltipDescription={props.description}
          fieldProps={{ ...props }}
          isRequired={props.isRequired}
          {...props.labelProps}
        />
      )}
      {ready && readOnlySettings && (
        <div className="readonly-toolbar">
          {ready && (
            <div
              className={classNames("readonly-container", {
                "bp5-disabled bp5-input": !props.minimal,
              })}
            >
              {readOnlySettings.leftIcon && (
                <Icon icon={readOnlySettings.leftIcon} />
              )}

              <div>{readOnlySettings.value}</div>
            </div>
          )}
        </div>
      )}
      {props.errorMessages && (
        <FormFieldErrorContainer errorMessages={props.errorMessages} />
      )}
    </FormGroup>
  );
};
